"use client"

import { motion } from "framer-motion"
import { useInView } from "framer-motion"
import { useRef } from "react"
import Image from "next/image"
import { LIST_IMAGE } from "@/assets"

const partners = [
  { name: "Vinamilk", logo: LIST_IMAGE.customer1 },
  { name: "Unilever", logo: LIST_IMAGE.customer2 },
  { name: "Nestle", logo: LIST_IMAGE.customer3 },
  { name: "Samsung", logo: LIST_IMAGE.customer5 },
]

// Duplicate partners for seamless loop
const duplicatedPartners = [...partners, ...partners]

export default function PartnersSection() {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true })

  return (
    <section className="py-12">
      <div className="w-screen bg-[#273647] py-8 mb-8">
        <h2 className="text-4xl md:text-5xl font-display text-white text-center">
          ĐỐI TÁC TIN CẬY
        </h2>
      </div>
      <div className="container mx-auto px-4 relative overflow-hidden" ref={ref}>
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >

          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Sợi Cửu Long Là đối tác tin cậy của nhiều thương hiệu lớn trong và ngoài nước
          </p>
          <div className="w-24 h-1 bg-primary mx-auto mt-6"></div>
        </motion.div>

        {/* Auto-scrolling partners */}
        <motion.div
          className="flex space-x-8 min-w-max animate-scroll"
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ duration: 0.8 }}
        >
          {duplicatedPartners.map((partner, index) => (
            <motion.div
              key={`${partner.name}-${index}`}
              className="flex-shrink-0 w-52 h-32 relative bg-white shadow-md hover:shadow-lg transition-shadow group border border-gray-100"
              whileHover={{ scale: 1.05, y: -5 }}
              transition={{ duration: 0.3 }}
            >
              <Image
                src={partner.logo || "/placeholder.svg"}
                alt={partner.name}
                fill
                className="object-contain opacity-100 transition-opacity p-4"
              />
            </motion.div>
          ))}
        </motion.div>

        {/* Stats below partners */}
        <motion.div
          className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.4 }}
        >


          {[
            { number: "1000+ ", label: "TẤN SỢI/NĂM" },
            { number: "20+", label: "Tỉnh thành" },
            { number: "5+", label: "QUỐC GIA" },
            { number: "100%", label: "KHÁCH HÀNG HÀI LÒNG" },
          ].map((stat, index) => (
            <motion.div key={index} className="text-center" whileHover={{ scale: 1.05 }} transition={{ duration: 0.3 }}>
              <div className="text-3xl md:text-4xl font-display text-primary mb-2">{stat.number}</div>
              <div className="text-sm font-industrial text-secondary">{stat.label}</div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  )
}
